import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

export interface VipTierProgressState {
    tierProgress: number | null;
}

const createInitialState = (): VipTierProgressState => ({
    tierProgress: null,
});

@singleton()
@StoreConfig({ name: "RewardsVipTierProgressStore" })
class RewardsVipTierProgressStore extends BaseStore<VipTierProgressState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsVipTierProgressStore;
